import { toast } from 'sonner';

export interface TagSaveResult {
  ghlWarning?: string;
}

export const notifyTagSaved = (
  successMessage: string,
  result?: TagSaveResult,
) => {
  toast.success(successMessage, {
    id: 'tag-save-success',
    duration: 5000,
  });

  if (!result?.ghlWarning) {
    return;
  }

  // Show the warning on its own toast after success so they stack with a gap
  // instead of covering each other in the same slot.
  window.setTimeout(() => {
    toast.warning(result.ghlWarning, {
      id: 'tag-save-ghl-warning',
      duration: 8000,
    });
  }, 250);
};
